<ion-content>
  <ion-grid *ngIf="widgets" class="ion-fill-height">
    <ion-row class="ion-fill-height">
      <ion-col size="12" class="ion-fill-height">
        <metersenergy [period]="service.historyPeriod.value" [meters]="meters"></metersenergy>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
